import { Component } from "@angular/core";

@Component({
	selector: "f-br",
	templateUrl: "./component.html",
	styleUrls: ["./component.scss"]
})
export class BrComponent {}
